import React,{useState} from "react";
import { useParams } from "react-router-dom";
import client from "../../../api";
import { notifyError, notifyErrorInBottom, notifySuccess } from "../../../helper";

const RecipientModelWindow = (props) => {
    const {primaryHeads, secondaryHeads, displayModelWindow, setDisplayModelWindow,listToBeLinked} = props;
    
    const api = client();
    const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    const [mapping, setMapping] = useState({"email":"email"});
    const [error, setError] = useState({email:""});

    const handleSelectChange = (e) => {
        setMapping({...mapping,[e.target.name]:e.target.value});        
    }

    const onFocus = (e) => {
        setError({...error,[e.target.name]:""});
    }

    const onBlur = (e) => {
        if(!e.target.value.length){
            setError({...error,[e.target.name]:"Please select an option!"});
        }        
    }

    const saveFieldMapping = async () => {
        const is_valid = validateMapping(mapping);
        if(is_valid){
            try{
                setLoading(true);
                const payload = {
                    campaign_id:campaignID,
                    list_id:listToBeLinked,
                    mapping:mapping,
                    current_tab:"compose",
                    completed_tabs:["start", "add-recipients"] 
                }
                
                const response = await api.post('/v1/campaign/contactsList/update',payload);                            
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Contact List updated successfully');
                    setLoading(false);
                    setTimeout(()=>{
                        window.location.reload();
                    },1500);
                }
                
            } catch(error){
                console.log('error.message',error);
                setLoading(false);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
            }
        } else {
            notifyErrorInBottom('Please map the fields.');
        }
    }

    const validateMapping = (obj) => {
        return Object.keys(obj).length > 2            
    }
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Map CSV Columns</h2>
                    <p>Tell us about your CSV file and sync up the columns with existing csv file.</p>
                    <div className="column-wrap">
                        <div className="column column-1">
                            <h3>Special Columns:</h3>    
                            <div className="field-list">
                                {primaryHeads.map((head,key)=>(
                                    <div className="box" key={key}>
                                        <label htmlFor={head}>{head}</label>
                                        {secondaryHeads.length ? <select
                                            onChange={handleSelectChange} 
                                            name={head} 
                                            id={head} 
                                            readOnly = {head === "email"} 
                                            disabled = {head === "email"} 
                                            value = {mapping[head] !== undefined ? mapping[head] :''}
                                            onFocus={onFocus}
                                            onBlur={onBlur}
                                            >
                                            <option value={''}>Select</option>
                                            {secondaryHeads.map((row,i)=>(<option key={i} value={row} disabled={row === "email"}>{row}</option>))}
                                        </select>:''}
                                        {error[head] ? <span className="validation-error">{error[head]}</span>:''}
                                    </div>
                                ))}                                                                
                            </div>
                        </div>
                        <div className="column column-2">
                            <h3>Text Replacement Columns:</h3>
                            {primaryHeads.length ? <ul className="original-list">
                                {primaryHeads.map((row,i)=>(<li key={i}><i className='bx bxs-check-circle'></i> {row}</li>))}                                 
                            </ul>:''}
                        </div>
                    </div>
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "next-btn button--loading":"next-btn"} 
                            disabled={loading}
                            onClick={saveFieldMapping}>
                                <span className="button--text">Next</span>
                        </button>
                        
                        <button className="cancel-btn" onClick={()=>setDisplayModelWindow(false)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default RecipientModelWindow;